// Material Dashboard 2 React layouts
import Dashboard from "layouts/dashboard";
import MyEvents from "layouts/myEvents";
import MyDeadlines from "layouts/myDeadlines";
import Notifications from "layouts/notifications";
import Profile from "layouts/profile";
import SignIn from "layouts/authentication/sign-in";
import SignUp from "layouts/authentication/sign-up";
import EventRequest from "layouts/eventRequest";
import PublicEventRequest from "layouts/publicEventRequest";
import AllUsers from "layouts/allUsers";
import Meeting from "layouts/meeting";
import PasswordResetRequest from "layouts/authentication/reset-password/passwordResetRequest";
import PasswordReset from "layouts/authentication/reset-password/passwordResetForm";
import Event from "layouts/event";
import Permission from "layouts/event/permission";
import Invoice from "layouts/event/invoice";
import VerifyEmail from "layouts/authentication/verifyEmail";
import PrivacyPolicy from "layouts/legalNotice/privacyPolicy";
import TermsAndConditions from "layouts/legalNotice/termsAndConditions";
// @mui icons
import Icon from "@mui/material/Icon";

import { basename } from "constant.js";

const getRoutes = (user) => {
  const commonRoutes = [
    {
      type: "hidden",
      name: "PublicEventRequest",
      key: "public-event-request",
      icon: <Icon fontSize="small">add_circle</Icon>,
      route: basename + "/richiesta-evento",
      component: <PublicEventRequest />,
    },
    {
      type: "hidden",
      name: "Invoice",
      key: "invoice",
      icon: <Icon fontSize="small">receipt_long</Icon>,
      route: basename + "/event/:eventId/invoice/:invoiceId/:userId/:token",
      component: <Invoice />,
    },
  ];

  const authRoutes = [
    {
      type: "collapse",
      name: "Dashboard",
      key: "dashboard",
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: basename + "/dashboard",
      component: <Dashboard />,
    },
    {
      type: "collapse",
      name: "Eventi",
      key: "myEvents",
      icon: <Icon fontSize="small">receipt_long</Icon>,
      route: basename + "/myEvents",
      component: <MyEvents />,
    },
    {
      type: "collapse",
      name: "Scadenze",
      key: "myDeadlines",
      icon: <Icon fontSize="small">eventAvailableIcon</Icon>,
      route: basename + "/myDeadlines",
      component: <MyDeadlines />,
    },
    {
      type: "collapse",
      name: "Nuova Richiesta",
      key: "eventRequest",
      icon: <Icon fontSize="small">add</Icon>,
      route: basename + "/eventRequest",
      component: <EventRequest />,
    },
    {
      type: "collapse",
      name: "Book a call",
      key: "meeting",
      icon: <Icon fontSize="small">phone</Icon>,
      route: basename + "/meeting",
      component: <Meeting />,
    },
    {
      type: "collapse",
      name: "Profilo",
      key: "profile",
      icon: <Icon fontSize="small">person</Icon>,
      route: basename + "/profile",
      component: <Profile />,
    },
    {
      type: "hidden",
      name: "Evento",
      key: "event",
      icon: <Icon fontSize="small">receipt_long</Icon>,
      route: basename + "/event/:eventId",
      component: <Event />,
    },
    {
      type: "hidden",
      name: "Permission",
      key: "permission",
      icon: <Icon fontSize="small">receipt_long</Icon>,
      route: basename + "/event/:eventId/permission/:permissionId",
      component: <Permission />,
    },
    {
      type: "hidden",
      name: "PasswordResetForm",
      key: "reset-form",
      icon: <Icon fontSize="small">assignment</Icon>,
      route: basename + "/authentication/reset-password/passwordResetForm/:token",
      component: <PasswordReset />,
    },
    {
      type: "title",
      name: "PrivacyPolicy",
      key: "privacy-policy",
      icon: <Icon fontSize="small">verified</Icon>,
      route: basename + "/legalNotice/privacyPolicy",
      component: <PrivacyPolicy />,
    },
    {
      type: "title",
      name: "TermsAndConditions",
      key: "terms-and-conditions",
      icon: <Icon fontSize="small">gavel</Icon>,
      route: basename + "/legalNotice/termsAndConditions",
      component: <TermsAndConditions />,
    }
  ];

  const adminRoutes = [
    {
      type: "collapse",
      name: "Dashboard",
      key: "dashboard",
      icon: <Icon fontSize="small">dashboard</Icon>,
      route: basename + "/dashboard",
      component: <Dashboard />,
    },
    {
      type: "collapse",
      name: "Tutti gli Eventi",
      key: "myEvents",
      icon: <Icon fontSize="small">receipt_long</Icon>,
      route: basename + "/myEvents",
      component: <MyEvents />,
    },
    {
      type: "collapse",
      name: "Scadenze",
      key: "myDeadlines",
      icon: <Icon fontSize="small">eventAvailableIcon</Icon>,
      route: basename + "/myDeadlines",
      component: <MyDeadlines />,
    },
    {
      type: "collapse",
      name: "Tutti gli Utenti",
      key: "allUsers",
      icon: <Icon fontSize="small">person</Icon>,
      route: basename + "/allUsers",
      component: <AllUsers />,
    },
    {
      type: "hidden",
      name: "Profilo Utente",
      key: "user_profile",
      icon: <Icon fontSize="small">person</Icon>,
      route: basename + "/profile/:userId",
      component: <Profile />,
    },
    {
      type: "hidden",
      name: "Evento",
      key: "event",
      icon: <Icon fontSize="small">receipt_long</Icon>,
      route: basename + "/event/:eventId",
      component: <Event />,
    },
    {
      type: "hidden",
      name: "Nuova Richiesta",
      key: "eventRequest",
      icon: <Icon fontSize="small">receipt_long</Icon>,
      route: basename + "/eventRequest/:userId",
      component: <EventRequest />,
    },
    {
      type: "hidden",
      name: "Permission",
      key: "permission",
      icon: <Icon fontSize="small">receipt_long</Icon>,
      route: basename + "/event/:eventId/permission/:permissionId",
      component: <Permission />,
    },
    {
      type: "title",
      name: "PasswordResetForm",
      key: "reset-form",
      icon: <Icon fontSize="small">assignment</Icon>,
      route: basename + "/authentication/reset-password/passwordResetForm/:token",
      component: <PasswordReset />,
    },
    {
      type: "title",
      name: "PrivacyPolicy",
      key: "privacy-policy",
      icon: <Icon fontSize="small">verified</Icon>,
      route: basename + "/legalNotice/privacyPolicy",
      component: <PrivacyPolicy />,
    },
    {
      type: "title",
      name: "TermsAndConditions",
      key: "terms-and-conditions",
      icon: <Icon fontSize="small">gavel</Icon>,
      route: basename + "/legalNotice/termsAndConditions",
      component: <TermsAndConditions />,
    }
  ];

  const guestRoutes = [
    {
      type: "collapse",
      name: "Richiedi Evento",
      key: "public-event-request",
      icon: <Icon fontSize="small">add_circle</Icon>,
      route: basename + "/richiesta-evento",
      component: <PublicEventRequest />,
    },
    {
      type: "collapse",
      name: "Accedi",
      key: "sign-in",
      icon: <Icon fontSize="small">login</Icon>,
      route: basename + "/authentication/sign-in",
      component: <SignIn />,
    },
    {
      type: "collapse",
      name: "Ragistrati",
      key: "sign-up",
      icon: <Icon fontSize="small">assignment</Icon>,
      route: basename + "/authentication/sign-up",
      component: <SignUp />,
    },
    {
      type: "title",
      name: "PasswordReset",
      key: "reset",
      icon: <Icon fontSize="small">assignment</Icon>,
      route: basename + "/authentication/reset-password/passwordResetRequest",
      component: <PasswordResetRequest />,
    },
    {
      type: "title",
      name: "PasswordResetForm",
      key: "reset-form",
      icon: <Icon fontSize="small">assignment</Icon>,
      route: basename + "/authentication/reset-password/passwordResetForm/:token",
      component: <PasswordReset />,
    },
    {
      type: "title",
      name: "VerifyEmail",
      key: "verify-email",
      icon: <Icon fontSize="small">verified</Icon>,
      route: basename + "/authentication/verifyEmail/:token",
      component: <VerifyEmail />,
    },
    {
      type: "title",
      name: "PrivacyPolicy",
      key: "privacy-policy",
      icon: <Icon fontSize="small">verified</Icon>,
      route: basename + "/legalNotice/privacyPolicy",
      component: <PrivacyPolicy />,
    },
    {
      type: "title",
      name: "TermsAndConditions",
      key: "terms-and-conditions",
      icon: <Icon fontSize="small">gavel</Icon>,
      route: basename + "/legalNotice/termsAndConditions",
      component: <TermsAndConditions />,
    }
  ];

  if (!user) {
    // Guest user
    return [...commonRoutes, ...guestRoutes];
  } else if (user.isAdmin) {
    // Admin user
    return [...commonRoutes, ...adminRoutes];
  } else {
    // Authenticated user
    return [...commonRoutes, ...authRoutes];
  }
};

export default getRoutes;
